import { Avatar, Button, Image, Chip } from "@nextui-org/react";
import React from "react";
import logo from "../../Images/logo.svg";
import { Colors, numColors } from "../../utils/constant";
import OrgCard from "./OrgCard";
import useGetAllOrganization from "../../hooks/useGetAllOrganization";
import CreateOrgButtton from "./CreateOrgButton";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBuilding, faUsers, faGlobe } from "@fortawesome/free-solid-svg-icons";
import {
  FugitiveCalculator,
  MobileCombustionCalculator,
  StationaryCombustionCalculator,
} from "../../utils/formulaCalulator";
import { getUserRoleFromLocal } from "../../utils/helper";

const OrgList = () => {
  const { OrgList, isLoading: isLoadingOrgList, err } = useGetAllOrganization();
  const UserLogged = JSON.parse(sessionStorage.getItem("userData"));
  const UserId = UserLogged && UserLogged.user.id;
  const email = UserLogged && UserLogged.user.email;
  const navigate = useNavigate();

  React.useEffect(() => {
    if (!UserLogged) {
      navigate("/sign-in");
    }

    const data = {
      Quantity: 12,
      "Fuel Type": "Coal Tar",
    };

    const data1 = {
      Quantity: 23,
      "Greenhouse gas": "C10F18 (AR4)",
    };

    const data2 = {
      "Vehicle Type": "Gasoline heavy-duty vehicles 1999",
      Quantity: 23,
      Distance: 21,
      "Fuel Type": "Coal Tar",
    };

    // FugitiveCalculator(data1)
    //   .then((data) => console.log(data))
    //   .catch((err) => console.log(err));

    StationaryCombustionCalculator(data)
      .then((data) => {})
      .catch((err) => console.log(err));

    // MobileCombustionCalculator(data2)
    //   .then((data) => console.log(data))
    //   .catch((err) => console.log(err));
  }, [UserLogged, navigate]);

  return (
    <div className="min-h-screen bg-neutral-50">
      {/* Header */}
      <div className="bg-white border-b border-neutral-200 px-4 sm:px-6 lg:px-8 py-4 shadow-sm">
        <div className="max-w-7xl mx-auto">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-4">
              <Image width={60} alt="Audyt Logo" src={logo} />
              <div className="hidden sm:block">
                <h2 className="text-lg font-semibold text-neutral-900">Organization Selection</h2>
                <p className="text-xs text-neutral-600">Choose your workspace</p>
              </div>
            </div>
            <div className="flex items-center gap-3">
              <Chip size="sm" variant="flat" color="default">
                <FontAwesomeIcon icon={faUsers} className="mr-1 text-xs" />
                {OrgList?.length || 0} Organizations
              </Chip>
              <Avatar
                showFallback
                className="h-8 w-8 cursor-pointer"
                color={Colors[UserId % numColors]}
                name={email?.toUpperCase().slice(0, 1)}
                src="https://images.unsplash.com/broken"
              />
            </div>
          </div>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        {/* Welcome Card */}
        <div className="bg-white rounded-lg border border-neutral-200 shadow-sm p-6 mb-8">
          <div className="flex flex-col lg:flex-row items-start lg:items-center justify-between gap-6">
            <div className="flex-1">
              <div className="flex items-center gap-3 mb-4">
                <div className="p-2 bg-primary-100 rounded-lg">
                  <FontAwesomeIcon icon={faBuilding} className="text-primary-600 text-lg" />
                </div>
                <div>
                  <h1 className="text-2xl font-bold text-neutral-900">Choose your Organization</h1>
                  <p className="text-neutral-600 text-sm mt-1">
                    Select an existing organization or create a new one to begin your ESG journey
                  </p>
                </div>
              </div>
              <p className="text-neutral-600 text-sm leading-relaxed max-w-3xl">
                To get started with your ESG (Environmental, Social, and Governance)
                metric scoring, you can either select an existing organization or
                create a new one. This will enable you to comprehensively evaluate
                and manage your organization's sustainability and ethical impact.
              </p>
            </div>
            <div className="flex-shrink-0">
              <CreateOrgButtton />
            </div>
          </div>
        </div>

        {/* Organizations Grid */}
        <div className="space-y-6">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-3">
              <h3 className="text-lg font-semibold text-neutral-900">Your Organizations</h3>
              <Chip size="sm" variant="flat" color="primary">
                {OrgList?.length || 0} available
              </Chip>
            </div>
          </div>
          
          {OrgList?.length > 0 ? (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {OrgList?.map((name) => (
                <OrgCard key={name.id} title={name} />
              ))}
            </div>
          ) : (
            <div className="bg-white rounded-lg border border-neutral-200 shadow-sm p-12 text-center">
              <div className="p-4 bg-neutral-100 rounded-full w-16 h-16 mx-auto mb-4 flex items-center justify-center">
                <FontAwesomeIcon icon={faBuilding} className="text-neutral-400 text-xl" />
              </div>
              <h3 className="text-lg font-semibold text-neutral-900 mb-2">No Organizations Found</h3>
              <p className="text-neutral-600 text-sm mb-6">
                You don't have any organizations yet. Create your first organization to get started.
              </p>
              <CreateOrgButtton />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default OrgList;
